import { createEnvelope, createEventEnvelopeHeaders, getSdkMetadataForEnvelopeHeader } from '@sentry/utils';
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */

function createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
  return createEnvelope(createEventEnvelopeHeaders(replayEvent, getSdkMetadataForEnvelopeHeader(replayEvent), tunnel, dsn), [[{
    type: 'replay_event'
  }, replayEvent], [{
    type: 'replay_recording',
    length: recordingData.length
  }, recordingData]]);
}

export { createReplayEnvelope };